import styled from 'styled-components';

const DepositionsContainer = styled.div``;

export { DepositionsContainer };
